import http from "./http"
import { getToken } from './auth'
import i18n from '../i18n/i18n'
import { translateApiMessage } from '../i18n/apiMessages'

const base = 'email'

export async function emailInvoice(payload) {
  const config = {
      headers: {
          'Content-Type': 'application/json',
          'Authorization': 'Bearer ' + getToken(),
      }
  }

  const { data } = await http.post(base + '/invoice', payload, config)
  return data
}

export async function getInvoicePdf(jobId) {
  const response = await http.get(`${base}/invoice/${jobId}/pdf`, {
    headers: { 'Authorization': 'Bearer ' + getToken() },
    responseType: 'blob'
  })
  const contentType = response.headers?.['content-type'] || ''
  if (response.status !== 200 || !contentType.includes('application/pdf')) {
    let message = i18n.t('invoiceShare.pdfNotPrepared')
    try {
      const body = JSON.parse(await response.data.text())
      message = translateApiMessage(body?.message || body?.error) || message
    } catch (_) { /* The server did not return JSON. */ }
    throw new Error(message)
  }
  return response.data
}

export async function createInvoiceShareLink(jobId) {
  const { data } = await http.post(`${base}/invoice/${jobId}/share-link`, {}, {
    headers: { 'Authorization': 'Bearer ' + getToken() }
  })
  return data
}
